import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import './Estilo.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'

const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    fecha: new Date,
    comentario: "",
    estatus: 0
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    totalLinea: 0.00,
    fecha: new Date
}
const modeloDatosc = {
    clienteID: 0,
    empresaID: 1,
    descripcion: "",
    rnc: "",
    direccion: "",
    telefono: "",
    correo: ""


}

var SubTotal = 0.00;
var totalDescuento = 0.00;
var totalITBIS = 0.00;
var totalPago = 0.00;
var impresion = '';
var Leatendio = '';

const CuadreCajaNCF = () => {
    let { Pedido } = useParams();
   

    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [buscarPor, setBuscarPor] = useState("fecha")
    const [ventas, setVentas] = useState([])


    const buscarVenta = async () => {
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        

        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");


        //  let response = await fetch(Api + `VentasTrans/HistorialFactura?buscarPor=${buscarPor}&fechaInicio=${_fechaInicio}&fechaFin=${_fechaFin}`)
        let response = await fetch(Api + "VentasTrans/HistorialFactura/" + buscarPor + "/" + fi + "/" + ff)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((dataJson) => {
                var data = dataJson;
                if (data.length >= 1) {

                    var d = data.filter(x => x.ncf.substr(0, 1) == 'B').map(e =>e)
                    setVentas(d);
                }
            })
    }
    useEffect(() => {
        buscarVenta();
    }, [fechaInicio || fechaFin])


    return (
        <>
            <div className="containerNCF " >
         
                <div class="page">
             
                    <div class="header">
                        <img ssrc="./imagen/LogoEmpresa/Logo.png" style={{ width: '200px', height: '150px' }} alt="Icono de la Empresa"/>
                            <div>
                                <div class="header-title">FERRETERIA Y TRANSPORTE SIMEON</div>
                                <p>
                                    LISTADO DE FACTURAS CON NCF
                               <br/>
                                DESDE <Input type="date" onChange={(e) => setFechaInicio(e.target.value)} value={moment(fechaInicio).format("YYYY-MM-DD")} />
                                HASTA <Input type="date" onChange={(e) => setFechaFin(e.target.value)} value={moment(fechaFin).format("YYYY-MM-DD")} />
                            </p>
                    </div>
                    <div class="header-info">
                            <p>Impreso el:  <br />{moment(Date.now()).format("DD/MM/YYYY : hh:mm:ss") }</p>
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>Factura</th>
                            <th>RNC</th>
                            <th>Nombre</th>
                            <th>NCF</th>
                            <th>Fecha</th>
                            <th>Sub Total</th>
                            <th>Impuestos</th>
                            <th>Total</th>
                            <th>Forma pago</th>
                        </tr>
                    </thead>
                        <tbody>
                            {ventas.map((item) => (
                                <tr key={item.facturaID}>
                                    {/*<td>{moment(item.fecha).format("DD/MM/YYYY")}</td>*/}
                                    <td>{item.facturaID}</td>
                                    <td>{item.rnc}</td>
                                    
                                    <td>{item.nombreCliente}</td>
                                    <td>{item.ncf}</td>
                                    <td>{moment(item.fecha).format("DD/MM/YYYY")}</td>
                                    <td>{(item.totalPago - item.totalITBIS).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    <td>{item.totalITBIS.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    <td>{item.totalPago.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    <td>{item.formaPago}</td>
                                </tr>))}
                     
                      
                    </tbody>
                </table>
           
            </div>
            </div>
        </>
        )

}
export default CuadreCajaNCF;